import { Edit, required, SimpleForm, TextInput, useRecordContext } from 'react-admin';
import { EditToolbar } from '../../common/EditToolbar';

const TestimonialCategoriesEdit = () => {
    return (
        <Edit mutationMode="pessimistic" title={<TestimonialTitle />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="name" fullWidth validate={[required()]} />
            </SimpleForm>
        </Edit>
    );
};

const TestimonialTitle = () => {
    const record = useRecordContext<any>();
    return record ? <span>{record?.name}</span> : null;
};

export default TestimonialCategoriesEdit;
